import React, { useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { fetchProfile, clearAuth } from '../../store/authSlice'

import MaintenancePage from '../../pages/Maintenance/MaintenancePage'
import MaintenanceBanner from './MaintenanceBanner'

interface PrivateRouteProps {
  children: React.ReactElement
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const location = useLocation()
  const dispatch = useAppDispatch()
  const token = localStorage.getItem('gowardhan_erp_token')
  const session = localStorage.getItem('gowardhan_erp_session')
  const isAuthenticated = !!(token || session === 'true')
  const profile = useAppSelector((state) => state.auth.profile)
  const profileError = useAppSelector((state) => state.auth.profileError)
  const isMaintenanceMode = useAppSelector((state) => state.app.isMaintenanceMode)

  useEffect(() => {
    if (isAuthenticated && !profile && !profileError) {
      dispatch(fetchProfile())
    }
  }, [isAuthenticated, profile, profileError, dispatch])

  useEffect(() => {
    if (profileError) {
      const lowerErr = profileError.toLowerCase()
      if (
        lowerErr.includes('token is invalid') ||
        lowerErr.includes('token is expired') ||
        lowerErr.includes('invalid token') ||
        lowerErr.includes('jwt expired') ||
        lowerErr.includes('unauthorized') ||
        lowerErr.includes('401')
      ) {
        localStorage.removeItem('gowardhan_erp_token')
        localStorage.removeItem('gowardhan_erp_session')
        localStorage.removeItem('gowardhan_erp_profile')
        dispatch(clearAuth())
      }
    }
  }, [profileError, dispatch])

  const currentToken = localStorage.getItem('gowardhan_erp_token')
  const currentSession = localStorage.getItem('gowardhan_erp_session')

  if (!currentToken && currentSession !== 'true') {
    return <Navigate to="/" state={{ from: location }} replace />
  }

  if (profileError) {
    const lowerErr = profileError.toLowerCase()
    if (
      lowerErr.includes('token is invalid') ||
      lowerErr.includes('token is expired') ||
      lowerErr.includes('invalid token') ||
      lowerErr.includes('jwt expired') ||
      lowerErr.includes('unauthorized') ||
      lowerErr.includes('401')
    ) {
      return <Navigate to="/" state={{ from: location }} replace />
    }
  }

  // Handle Maintenance Mode
  if (isMaintenanceMode) {
    const role = (profile?.role || profile?.user?.role || '').toString().toUpperCase()
    const isSuperAdmin = role === 'SUPER_ADMIN' || role === 'ADMIN'

    if (!isSuperAdmin) {
      return <MaintenancePage />
    }

    return (
      <>
        <MaintenanceBanner />
        {children}
      </>
    )
  }

  return children
}

export default PrivateRoute
